import { useLocation } from 'react-router-dom';
import { getUserProfile } from '~/helpers/userProfile';

/**
 * Rotas onde o chatbot Celsius AI deve aparecer.
 * Cada entrada faz match exato (`/x` casa apenas com `/x`)
 * OU prefixo (`/x` casa com `/x/algo/coisa`).
 *
 * Para liberar em uma rota nova, basta adicionar o pathname aqui.
 */
export const CELSIUS_AI_ALLOWED_ROUTES: string[] = [
  '/analise/manutencao',
];

export function isCelsiusAiAllowed(pathname: string): boolean {
  return CELSIUS_AI_ALLOWED_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
}

export function useIsCelsiusAiAllowed(): boolean {
  const { pathname } = useLocation();
  const profile = getUserProfile();
  const isAdminDiel = !!profile.permissions?.isAdminSistema;
  return isAdminDiel && isCelsiusAiAllowed(pathname);
}
